module.exports = __webpack_public_path__ + "static/media/carbon.d2f21696.jpg";